import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { useRecoilValue } from 'recoil';

import { cancelReEmitFor, socketEmit } from 'lib/clients/socket';
import { pm } from 'lib/helpers/utility';
import { useConfigSettings } from 'lib/hooks/queries/admin/useConfigurationSettings';

import AgTablePage from 'components/shared/AgTablePage/AgTablePage';
import state from 'components/state';

import FeatureFlagModal from './components/Modal';
import flattenFeatureFlags from './lib/flattenFeatureFlags';
import { DEFAULT_COLUMN_DEFS, DEFAULT_FILTERS } from './lib/table/defaultTableDefinitions';
import { cols } from './lib/table/featureFlagsCols';

const systemSettingsTabs = [
  {
    label: 'Feature Flags',
    value: null,
    permission: 'admin_feature_flag.read'
  }
];

const name = 'featureFlags';

const FeatureFlagsPage = () => {
  const permissions = useRecoilValue(state.permissions);

  useEffect(() => {
    socketEmit('feature-flags-init');
    return () => {
      socketEmit('feature-flags-leave');
      cancelReEmitFor('feature-flags-init');
    };
  }, []);

  return (
    <>
      <AgTablePage
        name={name}
        title="Dev Settings"
        switchItems={systemSettingsTabs}
        defaultColumns={cols}
        defaultFilters={DEFAULT_FILTERS}
        defaultColDef={DEFAULT_COLUMN_DEFS}
        useData={useConfigSettings}
        queryOptions={{
          select: (response) => ({
            [name]: flattenFeatureFlags(response?.configurations ?? []),
            count: Number(response?.total ?? 0)
          })
        }}
        ModalComponent={pm(permissions, 'admin_feature_flag.create') ? FeatureFlagModal : undefined}
        rowGroupPanelShow={false}
        keepOldFilters
      />
      <Outlet />
    </>
  );
};

export default FeatureFlagsPage;
